const HEX_CHARS = "0123456789abcdef";
export const calculateHashArrayBuffer = async (data: Uint8Array | ArrayBuffer): Promise<string | ""> => {
    try {
        const hash = await crypto.subtle.digest("SHA-256", data as Uint8Array<ArrayBuffer>);
        const bytes = new Uint8Array(hash);

        let hex = "";
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < bytes.length; i++) {
            const b = bytes[i];

            hex += HEX_CHARS[b >> 4] + HEX_CHARS[b & 0x0f];
        }
        return hex;
    } catch (error) {
        return "";
    }
};
export const hashCalculate = async (file: File): Promise<string | ""> => {
    return calculateHashArrayBuffer(await file.arrayBuffer());
};
